module.exports = __webpack_public_path__ + "img/21.6c665d61.jpg";